import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import useContent from "../../../hooks/useContent";
import useLanguage from "../../../hooks/useLanguage";

const formatDate = (ms) => {
  if (typeof ms !== "number") return "";
  const d = new Date(ms);
  return d.toLocaleString();
};

export default function DownloadsDialog({ open, target, onClose }) {
  const { getContentDownloads } = useContent();
  const [
    {
      pages: {
        statistics: { downloadsDialog: text },
      },
    },
  ] = useLanguage();

  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !target?.id) return;
    let cancelled = false;
    setLoading(true);
    getContentDownloads(target.id)
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data?.downloads) ? data.downloads : [];
        list.sort((a, b) => (b?.at || 0) - (a?.at || 0));
        setDownloads(list);
      })
      .catch(() => {
        if (!cancelled) setDownloads([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, target?.id]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {text.title}
        {target?.title && (
          <Typography
            variant="body2"
            sx={{ mt: 0.5, color: "text.secondary", fontWeight: 400 }}
          >
            {target.title}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        ) : downloads.length === 0 ? (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "text.secondary", py: 3 }}
          >
            {text.empty}
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{text.columns.user}</TableCell>
                  <TableCell>{text.columns.email}</TableCell>
                  <TableCell>{text.columns.date}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {downloads.map((d, i) => (
                  <TableRow key={`${d?.user?.id || "anon"}-${d?.at || i}`}>
                    <TableCell>{d?.user?.name || "—"}</TableCell>
                    <TableCell>{d?.user?.email || "—"}</TableCell>
                    <TableCell>{formatDate(d?.at)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {text.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
